export const ROLE = {
  ADMIN: "ADMIN",
  MANAGER: "MANAGER",
  STAFF: "STAFF",
};

export const DATA_SOURCE = {
  TCB: "TCB_FILE",
  MSC: "MSC_PREVIOUS_DATA",
};
